// import React, { useEffect, useMemo, useState, useRef } from 'react';
// import {
//    Box,
//    Button,
//    Checkbox,
//    Flex,
//    FormControl,
//    FormLabel,
//    Modal,
//    ModalBody,
//    ModalContent,
//    ModalFooter,
//    ModalHeader,
//    ModalOverlay,
//    IconButton,
//    HStack,
//    VStack,
//    useColorModeValue,
//    Divider,
//    Text,
//    Stack,
//    SimpleGrid,
//    GridItem,
//    Alert,
//    AlertIcon,
//    Table,
//    Thead,
//    Tr,
//    Th,
//    Tbody,
//    Td,
//    Input,
// } from '@chakra-ui/react';
// import { CloseIcon } from '@chakra-ui/icons';
// import { renderDynamicDropdown } from '../../../../../components/UIcomponents/DynamicDropdown';
// import { useDispatch, useSelector } from 'react-redux';
// import { useUser, useGlobal } from 'contexts';
// import { getItem } from '../../../../../redux/actions/item';
// import { postMergeCode } from '../../../../../redux/actions/utility';
// import { getWarehouse } from '../../../../../redux/actions/warehouse';
// import { getSerialToWarehouse } from '../../../../../redux/actions/salesLineDetail';
// import InputField from 'components/ui/InputField';
// import {
//    addStockTransfer,
//    updateStockTransfer,
//    getStockTransferLastDoc,
// } from '../../../../../redux/actions/stocktransfer';
// import { ref } from 'yup';

// export default function WarehouseForm({ isMergeCode, onClose, onMergeComplete, isEditMode, isEditData }) {
//    const [masterEntry, setMasterEntry] = useState(null);
//    const [deleteFromCode, setDeleteFromCode] = useState(false);
//    const [mergeOpeningBalance, setMergeOpeningBalance] = useState(false);
//    const [fromCode, setFromCode] = useState('');
//    const [toCode, setToCode] = useState('');
//    const dropdownRefs = useRef([]);
//    const docRefs = useRef();
//    const transactionAtRef = useRef();
//    const formWarehouseRef = useRef();
//    const toWarehouseRef = useRef();
//    const cancelRef = useRef();
//    const SaveRef = useRef();
//    const [itemData, setItemData] = useState([]);
//    const [selectedItems, setSelectedItems] = useState([]);
//    const [lineItemData, setLineItemData] = useState([]);

//    const items = useSelector((state) => state.item?.list || []);
//    const warehouses = useSelector((state) => state.warehouse?.list || []);
//    const SerialData = useSelector((state) => state.salesLineDetail.serial);
//    const lastDoc = useSelector((state) => state.stocktransfer?.last);
//    const dispatch = useDispatch();
//    const {user} = useUser();

//    // Enhanced color mode values
//    const bgColor = useColorModeValue('gray.50', '#2d3748');
//    const borderColor = useColorModeValue('gray.200', 'gray.600');
//    const textColor = useColorModeValue('gray.700', 'gray.200');
//    const modalContentBg = useColorModeValue('white', '#2d3748');
//    const sectionBg = useColorModeValue('gray.25', 'gray.750');
//    const labelColor = useColorModeValue('gray.600', 'gray.300');

//    const { userGlobalSettingsData } = useGlobal();
//    const shouldSendCompanyidItem = userGlobalSettingsData?.[0]?.askCompany?.item || false;
//    const shouldSendCompanyidWarehouse = userGlobalSettingsData?.[0]?.askCompany?.warehouse || false;

//    const [row, setRow] = useState({
//       formWarehouse: null,
//       toWarehouse: null,
//       item: null,
//       docno: '',
//       transactionAt: new Date().toISOString().split('T')[0],
//    });

//    const formWarehousesOption = row.toWarehouse !== null ? warehouses.filter((w) => w.id !== row.toWarehouse) : warehouses;
//    const toWarehousesOption = row.formWarehouse !== null ? warehouses.filter((w) => w.id !== row.formWarehouse) : warehouses;

//    // Form validation
//    const isFormValid = row.formWarehouse && row.toWarehouse && lineItemData.every(item => item.itemId);

//    useEffect(() => {
//       if (SerialData?.length > 0) {
//          const lineDetail = isEditData?.lineItems;
//          const formattedItems = SerialData.map((item) => {
//             const matchedLine = lineDetail?.find((ld) => ld?.lineDetail[0]?.serialNo === item.serialNo);

//             return {
//                id: matchedLine?.id ? matchedLine?.id : item?.id,
//                serialNo: item.serialNo,
//                serialNo2: item.serialNo2,
//                itemrate: matchedLine ? matchedLine.itemRate : item.itemrate,
//                itemName: item.itemName,
//                pcs: item.pcs,
//                isChecked: !!matchedLine,  // true if match found, false otherwise
//                ...(matchedLine ? { stock: matchedLine?.lineDetail[0] } : {}),
//             };
//          });
//          setItemData(formattedItems);
//       }
//    }, [SerialData]);

//    useEffect(() => {
//       if (isMergeCode && isEditData) {
//          console.log("Edit Data:", isEditData);
//       }
//    }, [isMergeCode, isEditData]);

//    // Reset form function
//    const resetForm = () => {
//       setRow({
//          formWarehouse: null,
//          toWarehouse: null,
//          item: null,
//          docno: '',
//          transactionAt: new Date().toISOString().split('T')[0],
//       })
//    };

//    // Reset form when modal closes
//    useEffect(() => {
//       if (!isMergeCode) {
//          resetForm();
//       }
//    }, [isMergeCode]);

//    useEffect(() => {
//       if (lastDoc && !isEditMode) {
//          setRow((prev) => ({
//             ...prev,
//             docno: lastDoc.docno ? Number(lastDoc.docno) + 1 : 1,
//          }));
//       }
//    }, [lastDoc]);

//    // Fetch data based on master type
//    useEffect(() => {
//       if (isMergeCode && user) {

//          const companyId = user?.loginhistory?.companyId || localStorage.getItem('companyId');
//          dispatch(getItem({ companyId, ...(shouldSendCompanyidItem && { companyIds: companyId }) }));
//          dispatch(getWarehouse({ ...(shouldSendCompanyidWarehouse && { companyIds: companyId }) }));
//          dispatch(getStockTransferLastDoc({ companyId }));

//          function formatDate(dateStr) {
//             const [day, month, year] = dateStr.split('/');
//             return `${year}-${month}-${day}`;
//          }

//          const runEditSetup = async () => {
//             if (isEditData) {
//                setRow({
//                   docno: isEditData?.docno,
//                   formWarehouse: isEditData?.fromWarehouseId,
//                   toWarehouse: isEditData?.toWarehouseId,
//                   transactionAt: formatDate(isEditData?.transactionAt),
//                });

//                const lineItems = isEditData?.lineItems || [];
//                const groupedMap = new Map();

//                lineItems.forEach((item) => {
//                   const key = item.itemId;
//                   const stock = (item.lineDetail || []).map((s) => ({
//                      ...s,
//                      itemrate: item.itemRate, // attach itemRate to each stock item
//                      id: item.id, // attach line item id
//                   }));

//                   if (groupedMap.has(key)) {
//                      // Merge stock arrays
//                      const existing = groupedMap.get(key);
//                      existing.stock = [...existing.stock, ...stock];
//                   } else {
//                      // New itemId entry
//                      groupedMap.set(key, {
//                         itemId: item.itemId,
//                         stock: stock,
//                      });
//                   }
//                });

//                const finalData = Array.from(groupedMap.values());

//                const lineData = await Promise.all(
//                   finalData.map(async (item) => {
//                      const data = {
//                         warehouseId: isEditData?.fromWarehouseId,
//                         itemId: item.itemId,
//                         companyId: companyId,
//                      };

//                      const respon = await dispatch(getSerialToWarehouse(data));
//                      const serials = respon?.payload || [];

//                      const match = respon.map((res) => ({
//                         id: res.id,
//                         serialNo: res.serialNo,
//                         serialNo2: res.serialNo2,
//                         itemrate: res.itemrate,
//                         itemName: res.itemName,
//                         pcs: res.pcs,
//                         isChecked: false,
//                      }));

//                      return {
//                         itemId: item.itemId,
//                         stock: [
//                            ...item.stock.map((s) => ({ ...s, isChecked: true })),
//                            ...match,
//                         ],
//                      };
//                   })
//                );

//                setLineItemData(lineData);
//             }
//          };

//          runEditSetup(); // run the async logic
//       }
//    }, [isMergeCode]);

//    const handleSave = async () => {
//       if (!isFormValid) return;

//       const companyId = user?.loginhistory?.companyId || parseInt(localStorage.getItem('companyId'));
//       const filterData = lineItemData
//          .flatMap((item) =>
//             (item.stock || [])
//                .filter((stock) => stock.isChecked)
//                .map((stock) => ({
//                   ...stock,
//                   itemId: item.itemId, // attach parent itemId to each stock
//                }))
//          );

//       const totalAmount = filterData.reduce(
//          (sum, item) => sum + parseFloat(item.itemrate || 0),
//          0
//       );

//       function formatDate(dateStr) {
//          const [day, month, year] = dateStr.split('/');
//          return `${year}-${month}-${day}`;
//       }

//       const payload = {
//          header: {
//             preFix: null,
//             docno: row.docno,
//             postFix: null,
//             transactionAt: row.transactionAt,
//             companyId: companyId,
//             netAmount: totalAmount,
//             notes: "",
//             fromWarehouseId: row.formWarehouse,
//             toWarehouseId: row.toWarehouse,
//             ...(isEditMode ? { id: isEditData.id } : {}),
//          },
//          lineItem: filterData.map((item) => ({
//             itemId: item.itemId,
//             lineNumber: 1,
//             itemRate: item.itemrate,
//             netAmount: item.itemrate,
//             qty1: 1,
//             qty2: 0,
//             qty3: 0,
//             notes: "",
//             stock: [
//                {
//                   itemId: item.itemId,
//                   itemName: item.itemName,
//                   pcs: item.pcs || 1,
//                   serialNo: item.serialNo || '',
//                   serialNo2: item.serialNo2 || '',
//                   quantity1: item.quantity1 || 1,
//                   quantity2: item.quantity2 || 0,
//                   quantity3: item.quantity3 || 0,
//                   notes: item.notes || '',
//                }
//             ],
//          })),
//       };

//       if (!isEditMode) {
//          await dispatch(addStockTransfer(payload));
//          onClose();
//       } else {
//          await dispatch(updateStockTransfer(payload));
//          onClose();
//       }
//    };

//    const handleClose = () => {
//       resetForm();
//       onClose();
//    };

//    const handleInputChange = (filed, value) => {
//       setRow((prev) => ({
//          ...prev,
//          [filed]: value,
//       }));
//    };

//    const handleItemChange = (field, value, index) => {
//       const updated = [...lineItemData];
//       updated[index] = {
//          ...updated[index],
//          [field]: value,
//       };
//       setLineItemData(updated);
//       if (field === 'itemId' && value !== null) {
//          fetchSerials(value, index);
//       }
//    };

//    const handleCheckChange = (index, checked) => {
//       const updated = [...SerialData];
//       updated[index] = { ...updated[index], isChecked: checked };

//       // dispatch(updateSerialData(updated)); // You need to create this action
//    };

//    const handlecheck = (id, index) => {
//       setLineItemData((prev) => {
//          const updated = [...prev];
//          updated[index].stock = updated[index].stock.map((item) => ({
//             ...item,
//             isChecked: item.id === id ? !item.isChecked : item.isChecked,
//          }));
//          return updated;
//       });
//    };

//    const handleSelectAll = (index) => {
//       if (lineItemData[index].stock?.every(item => item.isChecked)) {
//          setLineItemData((prev) => {
//             const updated = [...prev];
//             updated[index].stock = updated[index].stock.map((item) => ({
//                ...item,
//                isChecked: false,
//             }));
//             return updated;
//          });
//       } else {
//          setLineItemData((prev) => {
//             const updated = [...prev];
//             updated[index].stock = updated[index].stock.map((item) => ({
//                ...item,
//                isChecked: true,
//             }));
//             return updated;
//          });
//       }
//    };

//    const onFocusChange = (e, prevRef, nextRef) => {
//       const nextfocus = e.key === 'Enter' && !e.shiftKey || e.key === 'Tab' && !e.shiftKey;
//       const prevfocus = e.key === 'Enter' && e.shiftKey || e.key === 'Tab' && e.shiftKey;
//       if (nextfocus && nextRef) {
//          e.preventDefault();
//          nextRef.current?.focus();
//       } else if (prevfocus && prevRef) {
//          e.preventDefault();
//          prevRef.current?.focus();
//       }
//    };

//    const handleRateChange = (id, newRate, index) => {
//       const updatedStock = lineItemData[index].stock.map(item =>
//          item.id === id ? { ...item, itemrate: newRate } : item
//       );
//       setLineItemData((prev => {
//          const updated = [...prev];
//          updated[index].stock = updatedStock;
//          return updated;
//       }));
//    };

//    const fetchSerials = async (value, index) => {
//       if (user && row.formWarehouse && value) {
//          const companyId = user?.loginhistory?.companyId || localStorage.getItem('companyId');
//          const data = {
//             warehouseId: row.formWarehouse,
//             itemId: value,
//             companyId: companyId,
//          };
//          try {
//             const respon = await dispatch(getSerialToWarehouse(data));

//             const lineDetail = isEditData?.lineItems;
//             const formattedItems = respon.map((item) => {
//                const matchedLine = lineDetail?.find((ld) => ld?.lineDetail[0]?.serialNo === item.serialNo);

//                return {
//                   id: matchedLine?.id ? matchedLine?.id : item?.id,
//                   serialNo: item.serialNo,
//                   serialNo2: item.serialNo2,
//                   itemrate: matchedLine ? matchedLine.itemRate : item.itemrate,
//                   itemName: item.itemName,
//                   pcs: item.pcs,
//                   isChecked: !!matchedLine,  // true if match found, false otherwise
//                   ...(matchedLine ? { stock: matchedLine?.lineDetail[0] } : {}),
//                };
//             });

//             setLineItemData((prev) => {
//                const updated = [...prev];
//                updated[index].stock = (formattedItems).map((item) => ({
//                   ...item,
//                   isChecked: false,
//                }));
//                return updated;
//             });
//          } catch (error) {
//             console.error("Failed to fetch serials:", error);
//          }
//       }
//    };

//    // useEffect(() => {
//    //    fetchSerials();
//    // }, [row.formWarehouse, lineItemData]);

//    useEffect(() => {
//       if (isMergeCode && !isEditData) {
//          setLineItemData([
//             {
//                itemId: '',
//                stock: [],
//             }
//          ]);
//       }
//    }, [isMergeCode]);

//    useEffect(() => {
//       setTimeout(() => {
//          docRefs.current?.focus();
//       }, 100); // small delay sometimes helps
//    }, [isMergeCode]);

//    const addItemDropdown = () => {
//       setLineItemData((prev) => ([
//          ...prev,
//          {
//             itemId: '',
//             stock: [],
//          }
//       ]));

//       setTimeout(() => {
//          const lastIndex = dropdownRefs.current.length - 1;
//          if (dropdownRefs.current[lastIndex]) {
//             dropdownRefs.current[lastIndex].focus();
//          }
//       }, 100);
//    };

//    return (
//       <Modal isOpen={isMergeCode} onClose={handleClose} isCentered size="xl">
//          <ModalOverlay />
//          <ModalContent
//             borderWidth="1px"
//             borderColor={borderColor}
//             boxShadow="2xl"
//             borderRadius="xl"
//             bg={modalContentBg}
//             maxW="600px">
//             {/* Enhanced Header */}
//             <ModalHeader
//                fontSize="lg"
//                fontWeight="semibold"
//                py="2"
//                px="6"
//                borderTopRadius="xl"
//                borderBottomWidth="1px"
//                borderBottomColor={borderColor}>
//                <Flex justify="space-between" align="center">
//                   <HStack spacing="3">
//                      <Text>{isEditMode ? "Edit Stock Transfer" : "Add Stock Transfer"}</Text>
//                   </HStack>
//                   <IconButton
//                      aria-label="Close"
//                      icon={<CloseIcon />}
//                      size="sm"
//                      variant="ghost"
//                      _hover={{ bg: 'whiteAlpha.200' }}
//                      onClick={handleClose}
//                   />
//                </Flex>
//             </ModalHeader>

//             <ModalBody px="6" bg={bgColor}>
//                <VStack spacing="6" align="stretch">
//                   {/* Master Entry Selection */}
//                   <Box p="4" bg={sectionBg} borderRadius="lg" borderWidth="1px" borderColor={borderColor}>
//                      <VStack spacing="4" align="stretch">
//                         <FormControl display="flex">
//                            <GridItem w="100%" mr={5}>
//                               <InputField
//                                  ref={docRefs}
//                                  type="text"
//                                  name="docno"
//                                  label="Document Number"
//                                  value={row.docno}
//                                  onChange={(e) => handleInputChange('docno', e.target.value)}
//                                  onKeyDown={(e) => onFocusChange(e, null, transactionAtRef)}
//                               />
//                            </GridItem>
//                            <GridItem w="100%">
//                               <InputField
//                                  ref={transactionAtRef}
//                                  type="date"
//                                  name="transactionAt"
//                                  label="Transaction Date"
//                                  value={row.transactionAt}
//                                  onChange={(e) => handleInputChange('transactionAt', e.target.value)}
//                                  onKeyDown={(e) => onFocusChange(e, docRefs, formWarehouseRef)}
//                               />
//                            </GridItem>
//                         </FormControl>
//                         <FormControl display="flex">
//                            <GridItem className="seperator-width" mr={5}>
//                               {renderDynamicDropdown(
//                                  'formWarehouse',
//                                  'Form Warehouse',
//                                  formWarehousesOption,
//                                  {
//                                     value: row.formWarehouse,
//                                     onChange: (value) => handleInputChange('formWarehouse', value),
//                                     ref: formWarehouseRef,
//                                     onKeyDown: (e) => onFocusChange(e, transactionAtRef, toWarehouseRef),
//                                  },
//                                  {},
//                                  textColor,
//                                  false,
//                                  'Select master',
//                               )}
//                            </GridItem>
//                            <GridItem className="seperator-width">
//                               {renderDynamicDropdown(
//                                  'toWarehouse',
//                                  'To Warehouse',
//                                  toWarehousesOption,
//                                  {
//                                     value: row.toWarehouse,
//                                     onChange: (value) => handleInputChange('toWarehouse', value),
//                                     ref: toWarehouseRef,
//                                     onKeyDown: (e) => {
//                                        if (e.key === 'Enter' && e.shiftKey || e.key === 'Tab' && e.shiftKey) {
//                                           onFocusChange(e, formWarehouseRef, null);
//                                        } else if (e.key === 'Enter' && !e.shiftKey || e.key === 'Tab' && !e.shiftKey) {
//                                           dropdownRefs.current[0].focus();
//                                        }
//                                     },
//                                  },
//                                  {},
//                                  textColor,
//                                  false,
//                                  'Select master',
//                               )}
//                            </GridItem>
//                         </FormControl>
//                      </VStack>
//                   </Box>
//                   {lineItemData.map((lineItem, index) => (
//                      <Box key={index} p="4" bg={sectionBg} borderRadius="lg" borderWidth="1px" borderColor={borderColor}>
//                         <VStack spacing="4" align="stretch" mb={row.formWarehouse && lineItem.itemId ? 5 : 0}>
//                            <FormControl display="flex">
//                               <GridItem className="seperator-width" mr={index === lineItemData.length - 1 && lineItem.itemId ? 5 : 0}>
//                                  {renderDynamicDropdown(
//                                     'itemId',
//                                     `Item ${index + 1}`,
//                                     items,
//                                     {
//                                        value: lineItemData[index]?.itemId,
//                                        onChange: (value) => handleItemChange('itemId', value, index),
//                                        ref: (el) => (dropdownRefs.current[index] = el),
//                                        onKeyDown: (e) => {
//                                           if (e.key === 'Enter' && e.shiftKey || e.key === 'Tab' && e.shiftKey) {
//                                              if (index === 0) {
//                                                 toWarehouseRef.current?.focus();
//                                              } else {
//                                                 dropdownRefs.current[index - 1]?.focus();
//                                              }
//                                           } else if (e.key === 'Enter' && !e.shiftKey || e.key === 'Tab' && !e.shiftKey) {
//                                              if (lineItemData.length - 1 === index) {
//                                                 SaveRef.current?.focus();
//                                              } else {
//                                                 dropdownRefs.current[index + 1]?.focus();
//                                              }
//                                           }
//                                        },
//                                     },
//                                     {},
//                                     textColor,
//                                     false,
//                                     'Select master',
//                                  )}
//                               </GridItem>
//                               {index === lineItemData.length - 1 && lineItem.itemId && (
//                                  <Button
//                                     size="sm"
//                                     variant="outline"
//                                     onClick={addItemDropdown}
//                                     alignSelf="flex-start"
//                                  >
//                                     + Add Item
//                                  </Button>
//                               )}
//                            </FormControl>
//                         </VStack>

//                         {row.formWarehouse && lineItem.itemId && (
//                            <Box bg="gray.50" w="100%">
//                               {lineItem.stock?.length > 0 ? (
//                                  <Table size="sm" variant="simple" w="100%" border="1px" borderColor="gray.200">
//                                     <Thead bg="gray.100">
//                                        <Tr>
//                                           <Th fontWeight="bold" border="1px" borderColor="gray.300" borderTopLeftRadius="lg">
//                                              <Checkbox
//                                                 isChecked={lineItem.stock?.every(item => item.isChecked)}
//                                                 onChange={() => handleSelectAll(index)}
//                                              />
//                                           </Th>
//                                           <Th fontWeight="bold" border="1px" borderColor="gray.300">Serial No</Th>
//                                           <Th isNumeric fontWeight="bold" border="1px" borderColor="gray.300" borderTopRightRadius="lg">Rate</Th>
//                                        </Tr>
//                                     </Thead>
//                                     <Tbody>
//                                        {lineItem.stock.map((item, i) => (
//                                           <Tr key={i}>
//                                              <Td border="1px" borderColor="gray.200">
//                                                 <Checkbox
//                                                    isChecked={item.isChecked}
//                                                    onChange={() => handlecheck(item.id, index)}
//                                                 />
//                                              </Td>
//                                              <Td border="1px" borderColor="gray.200">
//                                                 <Text fontSize="14px">{item.serialNo || ''}</Text>
//                                              </Td>
//                                              <Td isNumeric border="1px" borderColor="gray.200">
//                                                 <Input
//                                                    size="sm"
//                                                    type="number"
//                                                    value={item.itemrate}
//                                                    onChange={(e) => handleRateChange(item.id, e.target.value, index)}
//                                                    isDisabled={!item.isChecked}
//                                                    textAlign="right"
//                                                    w="100px"
//                                                 />
//                                              </Td>
//                                           </Tr>
//                                        ))}
//                                     </Tbody>
//                                  </Table>
//                               ) : (
//                                  <Text textAlign="center" p={4} fontSize="sm" color="gray.500" bg={bgColor}>
//                                     No data found
//                                  </Text>
//                               )}
//                            </Box>
//                         )}
//                      </Box>
//                   ))}
//                </VStack>
//             </ModalBody>

//             {/* Enhanced Footer */}
//             <ModalFooter
//                justifyContent="right"
//                py="4"
//                px="6"
//                bg={bgColor}
//                borderTopWidth="1px"
//                borderTopColor={borderColor}
//                borderBottomRadius="xl">
//                <HStack spacing="3">
//                   <Button
//                      ref={cancelRef}
//                      onClick={handleClose}
//                      variant="outline"
//                      size="md"
//                      minW="32"
//                      borderColor={borderColor}
//                      color={textColor}
//                      fontWeight="semibold"
//                      _hover={{
//                         bg: useColorModeValue('gray.50', 'gray.700'),
//                         borderColor: useColorModeValue('gray.300', 'gray.500'),
//                         transform: 'translateY(-1px)',
//                      }}>
//                      Cancel
//                   </Button>
//                   <Button
//                      ref={SaveRef}
//                      onClick={handleSave}
//                      colorScheme="green"
//                      size="md"
//                      minW="32"
//                      fontWeight="semibold"
//                      isDisabled={!isFormValid}
//                      _hover={{
//                         transform: isFormValid ? 'translateY(-1px)' : 'none',
//                         boxShadow: isFormValid ? 'md' : 'none',
//                      }}>
//                      {isEditMode ? "Update" : "Save"}
//                   </Button>
//                </HStack>
//             </ModalFooter>
//          </ModalContent>
//       </Modal>
//    );
// }

import React, { useEffect, useMemo, useState, useRef } from 'react';
import {
   Box,
   Button,
   Checkbox,
   Flex,
   FormControl,
   FormLabel,
   Modal,
   ModalBody,
   ModalContent,
   ModalFooter,
   ModalHeader,
   ModalOverlay,
   IconButton,
   HStack,
   VStack,
   useColorModeValue,
   Divider,
   Text,
   Stack,
   SimpleGrid,
   GridItem,
   Alert,
   AlertIcon,
   Table,
   Thead,
   Tr,
   Th,
   Tbody,
   Td,
   Input,
   useColorMode,
} from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';
import { renderDynamicDropdown } from '../../../../../components/UIcomponents/DynamicDropdown';
import { useDispatch, useSelector } from 'react-redux';
import { useUser, useGlobal } from 'contexts';
import { getItem } from '../../../../../redux/actions/item';
import { postMergeCode } from '../../../../../redux/actions/utility';
import { getWarehouse } from '../../../../../redux/actions/warehouse';
import { getSerialToWarehouse } from '../../../../../redux/actions/salesLineDetail';
import InputField from 'components/ui/InputField';
import {
   addStockTransfer,
   updateStockTransfer,
   getStockTransferLastDoc,
} from '../../../../../redux/actions/stocktransfer';
import { ref } from 'yup';

export default function WarehouseForm({ isMergeCode, onClose, onMergeComplete, isEditMode, isEditData }) {
   const [masterEntry, setMasterEntry] = useState(null);
   const [deleteFromCode, setDeleteFromCode] = useState(false);
   const [mergeOpeningBalance, setMergeOpeningBalance] = useState(false);
   const [fromCode, setFromCode] = useState('');
   const [toCode, setToCode] = useState('');
   const dropdownRefs = useRef([]);
   const docRefs = useRef();
   const transactionAtRef = useRef();
   const formWarehouseRef = useRef();
   const toWarehouseRef = useRef();
   const cancelRef = useRef();
   const SaveRef = useRef();
   const [itemData, setItemData] = useState([]);
   const [selectedItems, setSelectedItems] = useState([]);
   const [lineItemData, setLineItemData] = useState([]);

   const items = useSelector((state) => state.item?.list || []);
   const warehouses = useSelector((state) => state.warehouse?.list || []);
   const SerialData = useSelector((state) => state.salesLineDetail.serial);
   const lastDoc = useSelector((state) => state.stocktransfer?.last);
   const dispatch = useDispatch();
   const { user } = useUser();
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';

   // Enhanced color mode values with Tailwind-like approach
   const bgColor = isDark ? 'bg-gray-900' : 'bg-gray-50';
   const modalContentBg = isDark ? 'bg-gray-800' : 'bg-white';
   const sectionBg = isDark ? 'bg-gray-750' : 'bg-gray-25';
   const borderColor = isDark ? 'border-gray-600' : 'border-gray-200';
   const textColor = isDark ? 'text-gray-200' : 'text-gray-700';
   const labelColor = isDark ? 'text-gray-300' : 'text-gray-600';
   const headerBg = isDark
      ? 'bg-gradient-to-r from-blue-900 to-purple-900'
      : 'bg-gradient-to-r from-blue-600 to-purple-600';
   const buttonHover = isDark ? 'hover:bg-gray-700' : 'hover:bg-gray-100';

   const { userGlobalSettingsData } = useGlobal();
   const shouldSendCompanyidItem = userGlobalSettingsData?.[0]?.askCompany?.item || false;
   const shouldSendCompanyidWarehouse = userGlobalSettingsData?.[0]?.askCompany?.warehouse || false;

   const [row, setRow] = useState({
      formWarehouse: null,
      toWarehouse: null,
      item: null,
      docno: '',
      transactionAt: new Date().toISOString().split('T')[0],
   });

   const formWarehousesOption =
      row.toWarehouse !== null ? warehouses.filter((w) => w.id !== row.toWarehouse) : warehouses;
   const toWarehousesOption =
      row.formWarehouse !== null ? warehouses.filter((w) => w.id !== row.formWarehouse) : warehouses;

   // Form validation
   const isFormValid = row.formWarehouse && row.toWarehouse && lineItemData.every((item) => item.itemId);

   useEffect(() => {
      if (SerialData?.length > 0) {
         const lineDetail = isEditData?.lineItems;
         const formattedItems = SerialData.map((item) => {
            const matchedLine = lineDetail?.find((ld) => ld?.lineDetail[0]?.serialNo === item.serialNo);

            return {
               id: matchedLine?.id ? matchedLine?.id : item?.id,
               serialNo: item.serialNo,
               serialNo2: item.serialNo2,
               itemrate: matchedLine ? matchedLine.itemRate : item.itemrate,
               itemName: item.itemName,
               pcs: item.pcs,
               isChecked: !!matchedLine, // true if match found, false otherwise
               ...(matchedLine ? { stock: matchedLine?.lineDetail[0] } : {}),
            };
         });
         setItemData(formattedItems);
      }
   }, [SerialData]);

   useEffect(() => {
      if (isMergeCode && isEditData) {
         console.log('Edit Data:', isEditData);
      }
   }, [isMergeCode, isEditData]);

   // Reset form function
   const resetForm = () => {
      setRow({
         formWarehouse: null,
         toWarehouse: null,
         item: null,
         docno: '',
         transactionAt: new Date().toISOString().split('T')[0],
      });
   };

   // Reset form when modal closes
   useEffect(() => {
      if (!isMergeCode) {
         resetForm();
      }
   }, [isMergeCode]);

   useEffect(() => {
      if (lastDoc && !isEditMode) {
         setRow((prev) => ({
            ...prev,
            docno: lastDoc.docno ? Number(lastDoc.docno) + 1 : 1,
         }));
      }
   }, [lastDoc]);

   // Fetch data based on master type
   useEffect(() => {
      if (isMergeCode && user) {
         const companyId = user?.loginhistory?.companyId || localStorage.getItem('companyId');
         dispatch(getItem({ companyId, ...(shouldSendCompanyidItem && { companyIds: companyId }) }));
         dispatch(getWarehouse({ ...(shouldSendCompanyidWarehouse && { companyIds: companyId }) }));
         dispatch(getStockTransferLastDoc({ companyId }));

         function formatDate(dateStr) {
            const [day, month, year] = dateStr.split('/');
            return `${year}-${month}-${day}`;
         }

         const runEditSetup = async () => {
            if (isEditData) {
               setRow({
                  docno: isEditData?.docno,
                  formWarehouse: isEditData?.fromWarehouseId,
                  toWarehouse: isEditData?.toWarehouseId,
                  transactionAt: formatDate(isEditData?.transactionAt),
               });

               const lineItems = isEditData?.lineItems || [];
               const groupedMap = new Map();

               lineItems.forEach((item) => {
                  const key = item.itemId;
                  const stock = (item.lineDetail || []).map((s) => ({
                     ...s,
                     itemrate: item.itemRate, // attach itemRate to each stock item
                     id: item.id, // attach line item id
                  }));

                  if (groupedMap.has(key)) {
                     // Merge stock arrays
                     const existing = groupedMap.get(key);
                     existing.stock = [...existing.stock, ...stock];
                  } else {
                     // New itemId entry
                     groupedMap.set(key, {
                        itemId: item.itemId,
                        stock: stock,
                     });
                  }
               });

               const finalData = Array.from(groupedMap.values());

               const lineData = await Promise.all(
                  finalData.map(async (item) => {
                     const data = {
                        warehouseId: isEditData?.fromWarehouseId,
                        itemId: item.itemId,
                        companyId: companyId,
                     };

                     const respon = await dispatch(getSerialToWarehouse(data));
                     const serials = respon?.payload || [];

                     const match = respon.map((res) => ({
                        id: res.id,
                        serialNo: res.serialNo,
                        serialNo2: res.serialNo2,
                        itemrate: res.itemrate,
                        itemName: res.itemName,
                        pcs: res.pcs,
                        isChecked: false,
                     }));

                     return {
                        itemId: item.itemId,
                        stock: [...item.stock.map((s) => ({ ...s, isChecked: true })), ...match],
                     };
                  }),
               );

               setLineItemData(lineData);
            }
         };

         runEditSetup(); // run the async logic
      }
   }, [isMergeCode]);

   const handleSave = async () => {
      if (!isFormValid) return;

      const companyId = user?.loginhistory?.companyId || parseInt(localStorage.getItem('companyId'));
      const filterData = lineItemData.flatMap((item) =>
         (item.stock || [])
            .filter((stock) => stock.isChecked)
            .map((stock) => ({
               ...stock,
               itemId: item.itemId, // attach parent itemId to each stock
            })),
      );

      const totalAmount = filterData.reduce((sum, item) => sum + parseFloat(item.itemrate || 0), 0);

      function formatDate(dateStr) {
         const [day, month, year] = dateStr.split('/');
         return `${year}-${month}-${day}`;
      }

      const payload = {
         header: {
            preFix: null,
            docno: row.docno,
            postFix: null,
            transactionAt: row.transactionAt,
            companyId: companyId,
            netAmount: totalAmount,
            notes: '',
            fromWarehouseId: row.formWarehouse,
            toWarehouseId: row.toWarehouse,
            ...(isEditMode ? { id: isEditData.id } : {}),
         },
         lineItem: filterData.map((item) => ({
            itemId: item.itemId,
            lineNumber: 1,
            itemRate: item.itemrate,
            netAmount: item.itemrate,
            qty1: 1,
            qty2: 0,
            qty3: 0,
            notes: '',
            stock: [
               {
                  itemId: item.itemId,
                  itemName: item.itemName,
                  pcs: item.pcs || 1,
                  serialNo: item.serialNo || '',
                  serialNo2: item.serialNo2 || '',
                  quantity1: item.quantity1 || 1,
                  quantity2: item.quantity2 || 0,
                  quantity3: item.quantity3 || 0,
                  notes: item.notes || '',
               },
            ],
         })),
      };

      if (!isEditMode) {
         await dispatch(addStockTransfer(payload));
         onClose();
      } else {
         await dispatch(updateStockTransfer(payload));
         onClose();
      }
   };

   const handleClose = () => {
      resetForm();
      onClose();
   };

   const handleInputChange = (filed, value) => {
      setRow((prev) => ({
         ...prev,
         [filed]: value,
      }));
   };

   const handleItemChange = (field, value, index) => {
      const updated = [...lineItemData];
      updated[index] = {
         ...updated[index],
         [field]: value,
      };
      setLineItemData(updated);
      if (field === 'itemId' && value !== null) {
         fetchSerials(value, index);
      }
   };

   const handleCheckChange = (index, checked) => {
      const updated = [...SerialData];
      updated[index] = { ...updated[index], isChecked: checked };

      // dispatch(updateSerialData(updated)); // You need to create this action
   };

   const handlecheck = (id, index) => {
      setLineItemData((prev) => {
         const updated = [...prev];
         updated[index].stock = updated[index].stock.map((item) => ({
            ...item,
            isChecked: item.id === id ? !item.isChecked : item.isChecked,
         }));
         return updated;
      });
   };

   const handleSelectAll = (index) => {
      if (lineItemData[index].stock?.every((item) => item.isChecked)) {
         setLineItemData((prev) => {
            const updated = [...prev];
            updated[index].stock = updated[index].stock.map((item) => ({
               ...item,
               isChecked: false,
            }));
            return updated;
         });
      } else {
         setLineItemData((prev) => {
            const updated = [...prev];
            updated[index].stock = updated[index].stock.map((item) => ({
               ...item,
               isChecked: true,
            }));
            return updated;
         });
      }
   };

   const onFocusChange = (e, prevRef, nextRef) => {
      const nextfocus = (e.key === 'Enter' && !e.shiftKey) || (e.key === 'Tab' && !e.shiftKey);
      const prevfocus = (e.key === 'Enter' && e.shiftKey) || (e.key === 'Tab' && e.shiftKey);
      if (nextfocus && nextRef) {
         e.preventDefault();
         nextRef.current?.focus();
      } else if (prevfocus && prevRef) {
         e.preventDefault();
         prevRef.current?.focus();
      }
   };

   const handleRateChange = (id, newRate, index) => {
      const updatedStock = lineItemData[index].stock.map((item) =>
         item.id === id ? { ...item, itemrate: newRate } : item,
      );
      setLineItemData((prev) => {
         const updated = [...prev];
         updated[index].stock = updatedStock;
         return updated;
      });
   };

   const fetchSerials = async (value, index) => {
      if (user && row.formWarehouse && value) {
         const companyId = user?.loginhistory?.companyId || localStorage.getItem('companyId');
         const data = {
            warehouseId: row.formWarehouse,
            itemId: value,
            companyId: companyId,
         };
         try {
            const respon = await dispatch(getSerialToWarehouse(data));

            const lineDetail = isEditData?.lineItems;
            const formattedItems = respon.map((item) => {
               const matchedLine = lineDetail?.find((ld) => ld?.lineDetail[0]?.serialNo === item.serialNo);

               return {
                  id: matchedLine?.id ? matchedLine?.id : item?.id,
                  serialNo: item.serialNo,
                  serialNo2: item.serialNo2,
                  itemrate: matchedLine ? matchedLine.itemRate : item.itemrate,
                  itemName: item.itemName,
                  pcs: item.pcs,
                  isChecked: !!matchedLine, // true if match found, false otherwise
                  ...(matchedLine ? { stock: matchedLine?.lineDetail[0] } : {}),
               };
            });

            setLineItemData((prev) => {
               const updated = [...prev];
               updated[index].stock = formattedItems.map((item) => ({
                  ...item,
                  isChecked: false,
               }));
               return updated;
            });
         } catch (error) {
            console.error('Failed to fetch serials:', error);
         }
      }
   };

   useEffect(() => {
      if (isMergeCode && !isEditData) {
         setLineItemData([
            {
               itemId: '',
               stock: [],
            },
         ]);
      }
   }, [isMergeCode]);

   useEffect(() => {
      setTimeout(() => {
         docRefs.current?.focus();
      }, 100); // small delay sometimes helps
   }, [isMergeCode]);

   const addItemDropdown = () => {
      setLineItemData((prev) => [
         ...prev,
         {
            itemId: '',
            stock: [],
         },
      ]);

      setTimeout(() => {
         const lastIndex = dropdownRefs.current.length - 1;
         if (dropdownRefs.current[lastIndex]) {
            dropdownRefs.current[lastIndex].focus();
         }
      }, 100);
   };

   return (
      <Modal isOpen={isMergeCode} onClose={handleClose} isCentered size="2xl">
         <ModalOverlay className="backdrop-blur-sm bg-black/30" />
         <ModalContent
            className={`w-full max-w-4xl h-auto max-h-[90vh] overflow-hidden rounded-2xl shadow-2xl ${modalContentBg} ${borderColor} border`}>
            {/* Premium Header with Gradient */}
            <ModalHeader
               className={`p-6 border-b rounded-t-lg bg-gradient-to-r ${
                  isEditMode ? 'from-emerald-400 to-sky-600' : 'from-emerald-400 to-sky-600'
               } text-white`}>
               <div className="flex justify-between items-center">
                  <div className="flex items-center space-x-3">
                     <div
                        className={`p-2 rounded-lg backdrop-blur-sm ${
                           isDark ? 'bg-white/10 border border-white/20' : 'bg-white/20 border border-white/30'
                        }`}>
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                           <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
                           />
                        </svg>
                     </div>
                     <div>
                        <h2 className="text-xl font-bold tracking-tight">
                           {isEditMode ? 'Edit Stock Transfer' : 'Create Stock Transfer'}
                        </h2>
                        <p className="text-blue-100 text-sm font-medium">
                           {isEditMode
                              ? 'Update existing transfer details'
                              : 'Create new stock transfer between warehouses'}
                        </p>
                     </div>
                  </div>
                  <IconButton
                     aria-label="Close"
                     icon={<CloseIcon />}
                     size="sm"
                     className={`rounded-lg backdrop-blur-sm ${
                        isDark
                           ? 'hover:bg-white/20 text-white border border-white/30'
                           : 'hover:bg-white/30 text-white border border-white/40'
                     }`}
                     onClick={handleClose}
                  />
               </div>
            </ModalHeader>

            <ModalBody className={`p-6 overflow-y-auto ${bgColor}`}>
               <div className="space-y-6">
                  {/* Document Information Card */}
                  <div
                     className={`rounded-xl border ${
                        isDark ? 'border-gray-600 bg-gray-750' : 'border-gray-200 bg-white'
                     } shadow-sm p-6`}>
                     <h3 className={`text-lg font-semibold mb-4 ${textColor} flex items-center space-x-2`}>
                        <svg className="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                           <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                           />
                        </svg>
                        <span>Document Information</span>
                     </h3>
                     <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                           <InputField
                              ref={docRefs}
                              type="text"
                              name="docno"
                              label="Document Number"
                              value={row.docno}
                              onChange={(e) => handleInputChange('docno', e.target.value)}
                              onKeyDown={(e) => onFocusChange(e, null, transactionAtRef)}
                              className={`rounded-lg ${
                                 isDark ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-300'
                              }`}
                           />
                        </div>
                        <div>
                           <InputField
                              ref={transactionAtRef}
                              type="date"
                              name="transactionAt"
                              label="Transaction Date"
                              value={row.transactionAt}
                              onChange={(e) => handleInputChange('transactionAt', e.target.value)}
                              onKeyDown={(e) => onFocusChange(e, docRefs, formWarehouseRef)}
                              className={`rounded-lg ${
                                 isDark ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-300'
                              }`}
                           />
                        </div>
                     </div>
                  </div>

                  {/* Warehouse Information Card */}
                  <div
                     className={`rounded-xl border ${
                        isDark ? 'border-gray-600 bg-gray-750' : 'border-gray-200 bg-white'
                     } shadow-sm p-6`}>
                     <h3 className={`text-lg font-semibold mb-4 ${textColor} flex items-center space-x-2`}>
                        <svg className="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                           <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                           />
                        </svg>
                        <span>Warehouse Details</span>
                     </h3>
                     <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                           {renderDynamicDropdown(
                              'formWarehouse',
                              'From Warehouse',
                              formWarehousesOption,
                              {
                                 value: row.formWarehouse,
                                 onChange: (value) => handleInputChange('formWarehouse', value),
                                 ref: formWarehouseRef,
                                 onKeyDown: (e) => onFocusChange(e, transactionAtRef, toWarehouseRef),
                              },
                              {
                                 className: `rounded-lg ${
                                    isDark ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-300'
                                 }`,
                              },
                              textColor,
                              false,
                              'Select source warehouse',
                           )}
                        </div>
                        <div>
                           {renderDynamicDropdown(
                              'toWarehouse',
                              'To Warehouse',
                              toWarehousesOption,
                              {
                                 value: row.toWarehouse,
                                 onChange: (value) => handleInputChange('toWarehouse', value),
                                 ref: toWarehouseRef,
                                 onKeyDown: (e) => {
                                    if ((e.key === 'Enter' && e.shiftKey) || (e.key === 'Tab' && e.shiftKey)) {
                                       onFocusChange(e, formWarehouseRef, null);
                                    } else if ((e.key === 'Enter' && !e.shiftKey) || (e.key === 'Tab' && !e.shiftKey)) {
                                       dropdownRefs.current[0].focus();
                                    }
                                 },
                              },
                              {
                                 className: `rounded-lg ${
                                    isDark ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-300'
                                 }`,
                              },
                              textColor,
                              false,
                              'Select destination warehouse',
                           )}
                        </div>
                     </div>
                  </div>

                  {/* Items Section */}
                  <div className="space-y-4">
                     {lineItemData.map((lineItem, index) => (
                        <div
                           key={index}
                           className={`rounded-xl border ${
                              isDark ? 'border-gray-600 bg-gray-750' : 'border-gray-200 bg-white'
                           } shadow-sm p-6 transition-all duration-200 hover:shadow-md`}>
                           <div className="flex items-center justify-between mb-4">
                              <h4 className={`text-md font-semibold ${textColor} flex items-center space-x-2`}>
                                 <svg
                                    className="w-4 h-4 text-purple-500"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24">
                                    <path
                                       strokeLinecap="round"
                                       strokeLinejoin="round"
                                       strokeWidth={2}
                                       d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
                                    />
                                 </svg>
                                 <span>Item {index + 1}</span>
                              </h4>
                              {index === lineItemData.length - 1 && lineItem.itemId && (
                                 <Button
                                    size="sm"
                                    className={`rounded-lg font-medium ${
                                       isDark
                                          ? 'bg-purple-600 hover:bg-purple-700 text-white'
                                          : 'bg-purple-500 hover:bg-purple-600 text-white'
                                    } transition-colors`}
                                    onClick={addItemDropdown}>
                                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                       <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth={2}
                                          d="M12 4v16m8-8H4"
                                       />
                                    </svg>
                                    Add Item
                                 </Button>
                              )}
                           </div>

                           <div className="mb-4">
                              {renderDynamicDropdown(
                                 'itemId',
                                 `Select Item`,
                                 items,
                                 {
                                    value: lineItemData[index]?.itemId,
                                    onChange: (value) => handleItemChange('itemId', value, index),
                                    ref: (el) => (dropdownRefs.current[index] = el),
                                    onKeyDown: (e) => {
                                       if ((e.key === 'Enter' && e.shiftKey) || (e.key === 'Tab' && e.shiftKey)) {
                                          if (index === 0) {
                                             toWarehouseRef.current?.focus();
                                          } else {
                                             dropdownRefs.current[index - 1]?.focus();
                                          }
                                       } else if (
                                          (e.key === 'Enter' && !e.shiftKey) ||
                                          (e.key === 'Tab' && !e.shiftKey)
                                       ) {
                                          if (lineItemData.length - 1 === index) {
                                             SaveRef.current?.focus();
                                          } else {
                                             dropdownRefs.current[index + 1]?.focus();
                                          }
                                       }
                                    },
                                 },
                                 {
                                    className: `rounded-lg ${
                                       isDark ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-300'
                                    }`,
                                 },
                                 textColor,
                                 false,
                                 'Select item to transfer',
                              )}
                           </div>

                           {/* Serial Numbers Table */}
                           {row.formWarehouse && lineItem.itemId && (
                              <div
                                 className={`rounded-lg border ${
                                    isDark ? 'border-gray-600 bg-gray-800' : 'border-gray-200 bg-gray-50'
                                 } overflow-hidden`}>
                                 {lineItem.stock?.length > 0 ? (
                                    <div className="overflow-x-auto">
                                       <table className="w-full text-sm">
                                          <thead>
                                             <tr className={isDark ? 'bg-gray-700' : 'bg-gray-100'}>
                                                <th className="p-3 text-left font-semibold border-r border-gray-300">
                                                   <Checkbox
                                                      isChecked={lineItem.stock?.every((item) => item.isChecked)}
                                                      onChange={() => handleSelectAll(index)}
                                                      className={isDark ? 'text-blue-400' : 'text-blue-600'}
                                                   />
                                                </th>
                                                <th
                                                   className={`p-3 text-left font-semibold ${
                                                      isDark ? 'text-gray-200' : 'text-gray-700'
                                                   }`}>
                                                   Serial Number
                                                </th>
                                                <th
                                                   className={`p-3 text-right font-semibold ${
                                                      isDark ? 'text-gray-200' : 'text-gray-700'
                                                   }`}>
                                                   Rate
                                                </th>
                                             </tr>
                                          </thead>
                                          <tbody>
                                             {lineItem.stock.map((item, i) => (
                                                <tr
                                                   key={i}
                                                   className={`border-t ${
                                                      isDark
                                                         ? 'border-gray-600 hover:bg-gray-700'
                                                         : 'border-gray-200 hover:bg-gray-100'
                                                   } transition-colors`}>
                                                   <td className="p-3 border-r border-gray-300">
                                                      <Checkbox
                                                         isChecked={item.isChecked}
                                                         onChange={() => handlecheck(item.id, index)}
                                                         className={isDark ? 'text-blue-400' : 'text-blue-600'}
                                                      />
                                                   </td>
                                                   <td className={`p-3 ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
                                                      {item.serialNo || 'N/A'}
                                                   </td>
                                                   <td className="p-3 text-right">
                                                      <Input
                                                         size="sm"
                                                         type="number"
                                                         value={item.itemrate}
                                                         onChange={(e) =>
                                                            handleRateChange(item.id, e.target.value, index)
                                                         }
                                                         isDisabled={!item.isChecked}
                                                         textAlign="right"
                                                         className={`w-24 ${
                                                            isDark
                                                               ? 'bg-gray-600 border-gray-500 text-white'
                                                               : 'bg-white border-gray-300'
                                                         } rounded ${!item.isChecked ? 'opacity-50' : ''}`}
                                                      />
                                                   </td>
                                                </tr>
                                             ))}
                                          </tbody>
                                       </table>
                                    </div>
                                 ) : (
                                    <div className="text-center p-8">
                                       <svg
                                          className="w-12 h-12 mx-auto text-gray-400 mb-3"
                                          fill="none"
                                          stroke="currentColor"
                                          viewBox="0 0 24 24">
                                          <path
                                             strokeLinecap="round"
                                             strokeLinejoin="round"
                                             strokeWidth={2}
                                             d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
                                          />
                                       </svg>
                                       <p className={isDark ? 'text-gray-400' : 'text-gray-500'}>
                                          No serial numbers found for this item
                                       </p>
                                    </div>
                                 )}
                              </div>
                           )}
                        </div>
                     ))}
                  </div>
               </div>
            </ModalBody>

            {/* Enhanced Footer */}
            <ModalFooter
               className={`p-6 border-t ${
                  isDark ? 'border-gray-600 bg-gray-800' : 'border-gray-200 bg-gray-50'
               } rounded-b-2xl`}>
               <div className="flex justify-end space-x-3 w-full">
                  <Button
                     ref={cancelRef}
                     onClick={handleClose}
                     className={`rounded-lg font-medium px-6 py-2.5 transition-all duration-200 ${
                        isDark
                           ? 'bg-gray-700 hover:bg-gray-600 text-gray-200 border border-gray-600 hover:border-gray-500'
                           : 'bg-white hover:bg-gray-100 text-gray-700 border border-gray-300 hover:border-gray-400'
                     } shadow-sm hover:shadow-md`}>
                     Cancel
                  </Button>
                  <Button
                     ref={SaveRef}
                     onClick={handleSave}
                     isDisabled={!isFormValid}
                     className={`rounded-lg font-medium px-6 py-2.5 transition-all duration-200 ${
                        isFormValid
                           ? isDark
                              ? 'bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white shadow-lg hover:shadow-xl transform hover:-translate-y-0.5'
                              : 'bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600 text-white shadow-lg hover:shadow-xl transform hover:-translate-y-0.5'
                           : isDark
                           ? 'bg-gray-600 text-gray-400 cursor-not-allowed'
                           : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                     }`}>
                     <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                     </svg>
                     {isEditMode ? 'Update Transfer' : 'Create Transfer'}
                  </Button>
               </div>
            </ModalFooter>
         </ModalContent>
      </Modal>
   );
}
